import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';



@Component({
    selector: 'app-layout',
    imports: [RouterOutlet, FormsModule],
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.css'
})
export class LayoutComponent {

  dropdownOpen = false;
  showModal = false;
  modalType = '';
  modalInput = '';
  activeTab: string = "home";

  constructor(private router: Router) { }

   isSidebarOpen = false;

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  

  navigateTo(path: string) {
       if (path === "home") {
      // "/" redirects to /login, which only lands on home because the login
      // guard bounces an authenticated user back. Go there directly.
      this.router.navigate(["/home"]);
      this.activeTab = "home";
    } else {
      this.router.navigate(["/vault", path]);
      this.activeTab = path;
    }
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  openCreateModal(type: string) {
    this.modalType = type;
    this.showModal = true;
    this.dropdownOpen = false;
  }

  closeModal() {
    this.showModal = false;
    this.modalInput = '';
  }

  createItem() {
    console.log(`Creating ${this.modalType}:`, this.modalInput);
    this.closeModal();
  }
  albumName: string = '';

  createAlbum() {
    console.log("Album created:", this.albumName);
    this.albumName = '';
    const modalElement = document.getElementById('createAlbumModal');
  }
}
